import * as tslib_1 from "tslib";
import { makeGetRequest } from 'owa-ows-gateway';
import { traceDomainStatus } from '../utils/domainOptionTracer';
var validatePremiumDomainUrl = 'ows/api/v1/PremiumDomain/validate';
export function validateDomain() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, makeGetRequest(validatePremiumDomainUrl)];
                case 1:
                    response = _a.sent();
                    traceDomainStatus(response);
                    return [2 /*return*/, response];
            }
        });
    });
}
//# sourceMappingURL=validateDomain.js.map